import { render, staticRenderFns } from "./AnnouncementReceipt.vue?vue&type=template&id=85a502b8&"
import script from "./AnnouncementReceipt.vue?vue&type=script&lang=js&"
export * from "./AnnouncementReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports